export interface IUpdateProfileRequest {
  email: string
  firstName: string
  lastName: string
  phoneNumber: string
}
